import { useQueryClient } from '@tanstack/react-query';

import {
  getApiV1LocationCountriesQueryOptions,
  useDeleteApiV1LocationCountriesId,
} from '@/shared/api/generated';

/**
 * Hook para excluir um País.
 *
 * Envolve o mutation gerado pelo Kubb para `DELETE /api/v1/location/countries/{id}`
 * e invalida o cache da listagem após a exclusão bem-sucedida.
 *
 * @example
 * ```tsx
 * const deleteCountry = useDeleteCountry();
 * deleteCountry.mutate({ id: 105 });
 * ```
 */
export function useDeleteCountry() {
  const queryClient = useQueryClient();

  return useDeleteApiV1LocationCountriesId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1LocationCountriesQueryOptions());
      },
    },
  });
}
